import {
  HEATMAP_COLORS,
  HEATMAPCLUSTERS_OPACITY,
  VIEW_MODES
} from '@aytm/app/stats/page/question-views/hm/components/chart/lib/constants'
import { getSvgDefs } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-defs'
import { createSvgRoot } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-root'
import { drawContoursByClusters } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/contours'

export const drawHeatmapByClusters = (container, options) => {
  const { id, answer, image, scale, width, height } = options
  const imageHeight = image?.original?.height

  const viewMode = VIEW_MODES.HEATMAPCLUSTERS

  if (!answer?.heatmap?.contours_by_polygons || !answer?.heatmap?.levels_by_polygons) return null

  const svg = createSvgRoot(container, { id, viewMode, width, height, scale })

  const defs = svg.append('defs')
  defs.html(getSvgDefs(id, viewMode))

  const group = svg.append('g').attr('id', `svg-${viewMode}-${id}-group`).style('opacity', 0.8)

  drawContoursByClusters(group, {
    id,
    contours: answer.heatmap.contours_by_polygons,
    levels: answer.heatmap.levels_by_polygons,
    imageHeight,
    colors: HEATMAP_COLORS,
    opacityValues: HEATMAPCLUSTERS_OPACITY
  })

  return null
}
